import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { isNil } from "lodash";
import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "30px",
    height: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  label: {
    margin: "2px",
    width: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    position: "relative",
  },
});

export const CollectionTimesLabel = ({ collection }) => {
  const styles = useStyles();

  const { sameDayCutOff, earliestReadyTime, latestReadyTime, saturnAuto } =
    collection;

  return (
    <Tooltip
      placement={"left"}
      enterDelay={500}
      enterNextDelay={500}
      title={
        <>
          {sameDayCutOff && <div>{`Same Day CutOff: ${sameDayCutOff}`}</div>}
          {earliestReadyTime && (
            <div>{`Earliest Ready Time: ${earliestReadyTime}`}</div>
          )}
          {latestReadyTime && (
            <div>{`Latest Ready Time: ${latestReadyTime}`}</div>
          )}
          {!isNil(saturnAuto) && (
            <div>{`Saturn Auto: ${saturnAuto ? "Yes" : "No"}`}</div>
          )}
        </>
      }
    >
      <div className={styles.container}>
        <div
          style={{
            background: palette.typography.black.solid,
            color: palette.typography.white.high,
          }}
          className={styles.label}
        >
          {"T"}
        </div>
      </div>
    </Tooltip>
  );
};
